<template>
  <div>
    <div
      class="dashboard-head d-flex align-items-center border-bottom pb-2 mb-3"
    >
      <h1 class="h2">{{ user.name }}</h1>
      <!-- <div class="dashboard-head__action pl-3 ml-auto">
        <button class="btn btn-secondary">action button</button>
      </div> -->
    </div>

    <div class="dashboard-body py-2">
      <b-card no-body class="border-0">
        <b-tabs fill small class="profile-tabs">
          <b-tab title="Основное" active>
            <b-card-text class="py-4">
              <b-form @submit.prevent="onSubmit" class="col-md-6 col-lg-4 px-0">
                <b-overlay
                  :show="loader"
                  rounded="sm"
                  variant="white"
                  opacity=".35"
                  blur="4px"
                >
                  <b-form-group
                    id="input-group-1"
                    label="Имя, фамилия"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      v-model="$v.form.name.$model"
                      :state="validateState('name')"
                      type="text"
                      placeholder="Имя, Фамилия"
                    ></b-form-input>
                    <b-form-invalid-feedback v-if="!$v.form.name.minLength"
                      >Минимальная длина:
                      {{ $v.form.name.$params.minLength.min }}
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="!$v.form.name.required"
                      >Необходимо ввести Имя, Фамилию
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-button type="submit" variant="default" class="bg-teal">
                    Сохранить
                  </b-button>
                </b-overlay>
              </b-form>
            </b-card-text>
          </b-tab>
          <b-tab title="Безопасность">
            <b-card-text class="py-4">
              <h5>Изменить пароль</h5>
              <b-form
                @submit.prevent="onSubmitChangePassword"
                class="col-md-6 col-lg-4 px-0"
              >
                <b-overlay
                  :show="loader"
                  rounded="sm"
                  variant="white"
                  opacity=".35"
                  blur="4px"
                  class=""
                >
                  <b-form-group
                    id="input-group-1"
                    label="Текущий пароль"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      v-model="$v.formChangePassword.password.$model"
                      :state="validateStatePassword('password')"
                      type="text"
                      placeholder="******"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      v-if="!$v.formChangePassword.password.minLength"
                      >Минимальная длина:
                      {{ $v.formChangePassword.password.$params.minLength.min }}
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback
                      v-if="!$v.formChangePassword.password.required"
                      >Необходимо ввести текущий пароль
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group
                    id="input-group-2"
                    label="Новый пароль"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-2"
                      v-model="$v.formChangePassword.newPassword.$model"
                      :state="validateStatePassword('newPassword')"
                      type="text"
                      placeholder="******"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      v-if="!$v.formChangePassword.newPassword.minLength"
                      >Минимальная длина:
                      {{
                        $v.formChangePassword.newPassword.$params.minLength.min
                      }}
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback
                      v-if="!$v.formChangePassword.newPassword.required"
                      >Необходимо ввести Имя, Фамилию
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group>
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="formChangePassword.closeSession"
                      name="checkbox-1"
                      :value="true"
                      :unchecked-value="false"
                    >
                      Выйти со всех устройств
                    </b-form-checkbox>
                  </b-form-group>

                  <b-button type="submit" variant="default" class="bg-teal">
                    Сохранить
                  </b-button>
                </b-overlay>
              </b-form>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';
import msg from '@/utils/messages';

export default {
  metaInfo() {
    return {
      title: msg.PAGE_TITLE_PROFILE,
      titleTemplate: `${this.siteName || ''} - %s`
    };
  },
  data() {
    return {
      loader: false,
      form: {
        name: ''
      },
      formChangePassword: {
        password: '',
        newPassword: '',
        closeSession: false
      }
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3)
      }
    },
    formChangePassword: {
      password: {
        required,
        minLength: minLength(6)
      },
      newPassword: {
        required,
        minLength: minLength(6)
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    siteName() {
      return this.$store.getters.getSiteParams?.siteName;
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateStatePassword(name) {
      const { $dirty, $error } = this.$v.formChangePassword[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        this.$v.$touch();
        return;
      }

      this.loader = true;

      try {
        await this.$store.dispatch('updateUser', this.form);
        this.$toast('Информация успешно обновлена!');
        this.form.name = '';
        this.$v.$reset();
        this.loader = false;
      } catch (e) {
        //
      }
    },
    async onSubmitChangePassword() {
      this.$v.formChangePassword.$touch();
      if (this.$v.formChangePassword.$anyError) {
        this.$v.$touch();
        return;
      }

      this.loader = true;

      try {
        await this.$store.dispatch('changePassword', this.formChangePassword);
        this.$toast('Информация успешно обновлена!');
        this.formChangePassword.password = '';
        this.formChangePassword.newPassword = '';
        this.formChangePassword.closeSession = false;
        this.$v.$reset();
        this.loader = false;
      } catch (e) {
        this.loader = false;
        //
      }
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/styles/vars.scss';
.profile-tabs .nav-tabs .nav-item.show .nav-link,
.profile-tabs .nav-tabs .nav-link.active {
  background-color: $green;
  color: #fff;
}

.profile-tabs .nav-tabs .nav-link {
  color: var(--gray-dark);
}
</style>
